module.exports = __webpack_public_path__ + "img/sustainability@2x.41313a9.webp";